/**
 * Raw PCM s16le from a streamed response, as Float32 samples. Network chunks can split a sample in half, so
 * an odd trailing byte is carried into the next chunk.
 */
export class PcmDecoder {
    private carry: number | null = null

    push(chunk: Uint8Array): Float32Array {
        let bytes = chunk
        if (this.carry !== null) {
            const joined = new Uint8Array(chunk.length + 1)
            joined[0] = this.carry
            joined.set(chunk, 1)
            bytes = joined
            this.carry = null
        }
        const even = bytes.length - (bytes.length % 2)
        if (even < bytes.length) this.carry = bytes[bytes.length - 1]
        const out = new Float32Array(even / 2)
        const view = new DataView(bytes.buffer, bytes.byteOffset, even)
        for (let i = 0; i < out.length; i++) out[i] = view.getInt16(i * 2, true) / 0x8000
        return out
    }
}

/** Collects decoded samples into play-sized blocks: a short first block (start fast), longer ones after. */
export class SampleBlocks {
    private parts: Float32Array[] = []
    private size = 0
    private first = true

    constructor(private firstMin: number, private min: number) {}

    push(samples: Float32Array): Float32Array[] {
        if (samples.length) {
            this.parts.push(samples)
            this.size += samples.length
        }
        const want = this.first ? this.firstMin : this.min
        if (this.size < want) return []
        return [this.take()]
    }

    /** End of stream: whatever is left. */
    end(): Float32Array[] {
        return this.size ? [this.take()] : []
    }

    private take(): Float32Array {
        const out = new Float32Array(this.size)
        let at = 0
        for (const p of this.parts) {
            out.set(p, at)
            at += p.length
        }
        this.parts = []
        this.size = 0
        this.first = false
        return out
    }
}
